/* Anbieterangaben für Impressum, AGB, Widerrufsbelehrung und
   Datenschutzerklärung — an einer Stelle, damit eine neue Anschrift nicht
   in fünf Dateien nachgezogen werden muss. */
export const ANBIETER = {
  geschaeftsbezeichnung: "Robin Foss Software",
  inhaber: "Robin Foss",
  strasse: "Horremer Straße 7",
  ort: "41470 Neuss",
  land: "Deutschland",
  email: "schriftbot@gmail.com",
  website: "schriftbot.com",
};

export const ANBIETER_EINZEILIG = `${ANBIETER.geschaeftsbezeichnung}, ${ANBIETER.inhaber}, ${ANBIETER.strasse}, ${ANBIETER.ort}`;

export default ANBIETER;
